<template>
  <div id="pddPrinting-new">
    <div class="">
      <orderCenter :accountList='accountList' :statusOpts='statusOpts'></orderCenter>
    </div>
  </div>
</template>
<script>
import netAPI from '@/api';
import dataSummary from './components/dataSummary';
import orderCenter from './components/orderCenter';
export default {
  name: 'collectionDataMonitoring',
  components: {
    dataSummary,
    orderCenter
  },
  filters: {},
  data() {
    return {
      activeName: 'chartStatict',
      accountList: [], // 子账号列表
      statusOpts: [] // 订单状态
    };
  },
  mounted() {
    // 子账号列表
    this.getSubAccount();
    // 订单来源
    this.getOrderSource();
  },
  methods: {
    // 获取子账号列表
    getSubAccount() {
      netAPI.getSubAccount().then(res => {
        if (res.success) {
          let list = res.data || [];
          this.accountList = [{userName: '全部', userId: '0'}].concat(list);
        } else {
          this.accountList = [];
        }
      }).catch(() => {
        this.accountList = [];
      });
    },
    // 订单来源
    getOrderSource() {
      // 查询条件——订单状态选项获取
      netAPI.getOrderStatus().then(res => {
        if (res.success) {
          this.statusOpts = res.data || [];
        } else {
          this.statusOpts = [];
        }
      }).catch(() => {
        this.statusOpts = [];
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>

</style>
